import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const negatives = ['This is not a random collection of aviation information.', 'This is not a generic flight theory book.', 'This is not a collection of disconnected worksheets.', 'And it is not another resource that leaves you with hours of preparation before you can actually use it.'];
const workflow = [{
  step: 'OPEN',
  detail: 'Open the system.'
}, {
  step: 'CHOOSE',
  detail: 'Choose the lesson objective.'
}, {
  step: 'SEE',
  detail: 'Show the visual.'
}, {
  step: 'TEACH',
  detail: 'Teach the lesson.'
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-blue-950 relative overflow-hidden" data-id="element-255" data-mp="13zy0ui3wug7l">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-1 bg-orange-500" data-id="element-256" data-mp="2jh7x6kuhpbdu" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-257" data-mp="2ffmnt9h5zf8e">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-258" data-mp="2ff34ppfs2kss">
          <p className="text-sm md:text-base font-semibold text-white/80 mb-4" data-id="element-259" data-mp="2gt8s7pm135v9">
            The Complete Visual Flight Teaching System for Instructors Worldwide
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-extrabold mb-4 text-white" data-id="element-260" data-mp="2pufao488mqr5">
            FLIGHT INSTRUCTOR <span className="text-orange-500" data-id="element-261" data-mp="1t6iqyqhi7fbp">READY</span>
          </h2>
          <p className="text-base md:text-lg text-white font-semibold mb-1" data-id="element-262" data-mp="1x6b1v9uddxk8">
            A Complete 6-in-1, 100% Visual Flight Teaching System
          </p>
          <p className="text-base md:text-lg text-white/75 mb-10" data-id="element-263" data-mp="223t2mcy8h6h5">
            6 Complete Volumes · 150 Ready-to-Teach Flight Lessons · 5 Professional Bonus Guides ·
            100% Visual
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-264" data-mp="1egbh2z5kb4mm">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease
        }} className="space-y-3 bg-white/5 p-6 rounded-2xl border border-white/15" data-id="element-265" data-mp="1eeia1ir1eie3">
            {negatives.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-266" data-mp="2mi7fagqvd2ul">
                <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-267" data-mp="2mk1wpl2xmctx" />
                <p className="text-white/75 text-sm" data-id="element-268" data-mp="1yswkdfw7a2od">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease
        }} className="bg-white p-6 rounded-2xl border-2 border-orange-500" data-id="element-269" data-mp="1tvcwrpdm4djr">
            <div className="flex items-start gap-3" data-id="element-270" data-mp="3j6ddolx76z0f">
              <Check className="text-blue-600 shrink-0 mt-1" size={20} data-id="element-271" data-mp="3e9wodoe9ielr" />
              <p className="text-blue-950 font-medium text-base leading-relaxed" data-id="element-272" data-mp="3mq5gfiejjuiq">
                Flight Instructor Ready is a complete 6-in-1 visual teaching system created
                specifically for flight instructors who want to plan less, explain flight concepts
                more clearly, correct students more effectively and build stronger training
                progressions.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="mt-12" data-id="element-273" data-mp="9c107lnmpox6">
          <p className="text-white/80 text-sm font-semibold uppercase tracking-widest mb-5" data-id="element-274" data-mp="eac8hry9zrda">
            The system follows a simple workflow
          </p>
          <ol className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-0" data-id="element-275" data-mp="3vqam9o436kus">
            {workflow.map((item, index) => <li key={item.step} className="relative flex flex-col items-center px-2" data-id="element-276" data-mp="4ifx5f76i4r4" data-mpi={index}>
                <span className="text-2xl md:text-3xl font-serif font-extrabold text-orange-500" data-id="element-277" data-mp="s8sh5ofp7ry2">
                  {item.step}
                </span>
                <span className="text-sm text-white/80 mt-1" data-id="element-278" data-mp="34kwmz6904naq">{item.detail}</span>
                {index < workflow.length - 1 && <span className="hidden md:block absolute right-0 top-2 translate-x-1/2 text-2xl text-white/40" aria-hidden="true" data-id="element-279" data-mp="30h8d2gwwdfmb">
                    →
                  </span>}
              </li>)}
          </ol>
          <p className="mt-8 text-sm md:text-base font-bold tracking-widest text-white" data-id="element-280" data-mp="3o7umabin15xw">
            OPEN → CHOOSE → SEE → TEACH
          </p>
        </div>
      </div>
    </section>;
}